import { REPORT_ADDRESS_PROPERTIES_EDITED } from 'redux/modules/address/actions/types';

export const reportAddressPropertiesEdited = address => ({
  type: REPORT_ADDRESS_PROPERTIES_EDITED,
  address,
});
